import { ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { GUARD_GROUPS } from "@/lib/promptGuards";

interface PromptGuardsProps {
  active: string[];
  onChange: (ids: string[]) => void;
}

export function PromptGuards({ active, onChange }: PromptGuardsProps) {
  const toggle = (id: string, on: boolean) => {
    onChange(on ? [...active, id] : active.filter((x) => x !== id));
  };

  return (
    <div className="rounded-xl border border-border/60 bg-secondary/15 p-3 space-y-3">
      <div className="flex items-center gap-1.5">
        <ShieldCheck className="w-3 h-3 text-muted-foreground/60" />
        <span className="text-[11px] font-medium text-muted-foreground flex-1">
          Zaštita proizvoda
        </span>
        <span className="text-[10px] text-muted-foreground/50">
          {active.length}/{GUARD_GROUPS.length}
        </span>
      </div>

      <div className="space-y-2.5">
        {GUARD_GROUPS.map((group) => (
          <div key={group.id} className="flex items-start gap-2">
            <Switch
              size="sm"
              checked={active.includes(group.id)}
              onCheckedChange={(on) => toggle(group.id, on)}
              className="mt-0.5"
            />
            <div className="min-w-0 flex-1">
              <div className="text-[11px] leading-tight text-foreground">{group.label}</div>
              <div className="text-[10px] leading-tight text-muted-foreground/60 mt-0.5">
                {group.hint}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
